/* eslint-disable spire/fenced-imports */
import { autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import { SelectBrandsFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import ProductSelector from "@insite/content-library/Components/ProductSelector";
import DynamicDropdown from "@insite/mobius/DynamicDropdown";
import StandardControl from "@insite/shell-public/Components/StandardControl";
import { EditorTemplateProps } from "@insite/shell-public/EditorTemplateProps";
import { loadSelectBrands, searchProducts } from "@insite/shell/Store/PageEditor/PageEditorActionCreators";
import { SelectBrandModel } from "@insite/shell/Store/PageEditor/PageEditorState";
import ShellState from "@insite/shell/Store/ShellState";
import debounce from "lodash/debounce";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
/* eslint-enable spire/fenced-imports */

interface CustomProductInfo {
    erpNumber: string;
}

interface State {
    products: ProductAutocompleteItemModel[] | null;
}

type OwnProps = EditorTemplateProps<CustomProductInfo, SelectBrandsFieldDefinition>;

const mapStateToProps = (state: ShellState) => {
    return {
        selectProducts: state.pageEditor.productSearchResults || [],
    };
};

const mapDispatchToProps = {
    searchProducts,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

class CustomSelectProductsField extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            products: [],
        };
    }

    debouncedSearchProducts = debounce(async (query: string) => {
        const res = await autocompleteSearch({
            query,
            brandEnabled: false,
            categoryEnabled: false,
            contentEnabled: false,
            productEnabled: true,
            spireContent: false
        });

        this.setState({ products: res.products })
    }, 300);

    onChange = (value?: string) => {
        if (!value) {
            return;
        }
        const found = this.state.products?.find?.(product => product.erpNumber === value);
        this.props.updateField(this.props.fieldDefinition.name, found!);
    };

    render() {
        const options = (this.state.products || []).map(option => ({ optionText: option.title, optionValue: option.erpNumber }));
        return (
            <StandardControl fieldDefinition={this.props.fieldDefinition as any}>
                <DynamicDropdown
                    uid={this.props.fieldDefinition.name}
                    onSelectionChange={this.onChange}
                    onInputChange={e => this.debouncedSearchProducts(e.currentTarget.value)}
                    options={options}
                    placeholder={translate("Select a Product")}
                    selected={this.props.fieldValue?.erpNumber || ""}
                    filterOption={() => true}
                />
            </StandardControl>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomSelectProductsField as any);
